import { Injectable } from '@angular/core';
import { CanActivate, Router } from "@angular/router";
import { Observable } from 'rxjs';
import { promise } from 'protractor';
import * as firebase from "firebase";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private router: Router) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise(
      (resolve, reject)=> {
        firebase.auth().onAuthStateChanged(
          (user)=> {
            if(user){

              var id = firebase.auth().currentUser.uid;
              var ref = firebase.database().ref("users");
              ref.orderByKey().equalTo(id).on("child_added", (snapshot) => {
                
                if(snapshot.val().actif == true){
                  resolve(true);
                }
                
              });

            }else{
              this.router.navigate(['/auth', 'signin']);
            }
          }
        )
      }
    )
  }
}
